import { FC, Fragment, useState } from 'react'
import classNames from 'classnames'
import { useWindowSize } from '@uidotdev/usehooks'
import { Link, useLocation } from 'react-router-dom'

import { SelectLanguage, Text } from 'components'
import routesList from 'libraries/router/routes'
import {
  Logo,
  BurgerMenuIcon,
  CloseIcon,
  MessageIcon,
  PhoneIcon,
  FacebookIcon,
  InstagramIcon,
  TelegramIcons,
} from 'assets'

import styles from './Header.module.scss'

const Header: FC = () => {
  const location = useLocation()
  const displaySize = useWindowSize()

  const [showSideBar, setShowSideBar] = useState(false)

  return (
    <>
      <header className={classNames(styles.header, 'bg_dark')}>
        <div className={classNames(styles.header__wrapper, 'container')}>
          <a href='/'>
            <img alt={'logo'} src={Logo} className={styles.page__logo} />
          </a>
          <ul className={styles.menu}>
            {routesList.map(item => (
              <Fragment key={item.title}>
                {item.title !== 'error' && !item.path.includes(':') && (
                  <li
                    className={classNames(styles.menu__item, {
                      [styles.menu__item__active]: location.pathname === item.path,
                    })}
                  >
                    <Link to={item.path}>
                      <Text text={item.title} />
                    </Link>
                  </li>
                )}
              </Fragment>
            ))}
          </ul>

          {Number(displaySize.width) > 900 && <SelectLanguage />}

          <BurgerMenuIcon
            className={styles.burger__menu}
            onClick={() => {
              setShowSideBar(true)
            }}
          />
        </div>
      </header>

      <div
        role='button'
        className={`${styles.overlay} ${showSideBar ? styles.show : styles.hide}`}
        onClick={() => {
          setShowSideBar(false)
        }}
      />
      <div className={`${styles.sidebar} ${showSideBar ? styles.show : styles.hide}`}>
        <div className={styles.sidebar__header}>
          <SelectLanguage />

          <CloseIcon
            className={styles.sidebar__close}
            onClick={() => {
              setShowSideBar(false)
            }}
          />
        </div>
        <ul className={styles.sidebar__menu}>
          {routesList.map(item => (
            <Fragment key={item.title}>
              {item.title !== 'error' && !item.path.includes(':') && (
                <li className={styles.sidebar__item}>
                  <Link
                    className={classNames(styles.sidebar__link, {
                      [styles.sidebar__link_active]: location.pathname === item.path,
                    })}
                    to={item.path}
                    onClick={() => setShowSideBar(false)}
                  >
                    <Text text={item.title} />
                    <span className={styles.sidebar__arrow} aria-hidden />
                  </Link>
                </li>
              )}
            </Fragment>
          ))}
        </ul>

        <div className={styles.sidebar__footer}>
          <a className={styles.sidebar__contact} href='mailto:info@engineeringgroup.am'>
            <span className={styles.sidebar__contact_icon}>
              <MessageIcon />
            </span>
            info@engineeringgroup.am
          </a>
          <a className={styles.sidebar__contact} href='tel:+37444144199'>
            <span className={styles.sidebar__contact_icon}>
              <PhoneIcon />
            </span>
            +374 44 144 199
          </a>
          <div className={styles.sidebar__socials} aria-hidden>
            <span className={styles.sidebar__social}>
              <FacebookIcon />
            </span>
            <span className={styles.sidebar__social}>
              <InstagramIcon />
            </span>
            <span className={styles.sidebar__social}>
              <TelegramIcons />
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
